import type { RuleConfig } from './types.tsx';

export const DISABLED = 'DISABLED' as const;
export const ENABLED = 'ENABLED' as const;
export const MISSING_PERMS = 'MISSING_PERMS' as const;

export const ANALYTICS_SOURCE = 'recurWorkItemForm';

export const SOFTWARE_END_USER_TEMPLATE_2 = 'software_end_user_template_2' as const;

export const EMPTY_RULE_CONFIG: RuleConfig = {
	automationRuleUuid: null,
	token: null,
	templateId: null,
	recurOnScheduleConfig: {
		rRule: null,
		dueDateOffsetSmartValue: null,
		recurCondition: null,
	},
};
